/**
 * Sleep for a fixed duration (used between bootstrap retries).
 */
export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

export interface RetryWithDelayOptions {
  maxAttempts: number;
  delayMs: number;
  onRetry?: (nextAttempt: number) => void;
}

/**
 * Runs `fn` up to `maxAttempts` times; waits `delayMs` between failures.
 * The last thrown error is rethrown if all attempts fail.
 */
export async function retryWithDelay<T>(
  fn: (attemptIndex: number) => Promise<T>,
  options: RetryWithDelayOptions,
): Promise<T> {
  let lastError: unknown;
  for (let attempt = 1; attempt <= options.maxAttempts; attempt++) {
    try {
      return await fn(attempt);
    } catch (error) {
      lastError = error;
      if (attempt < options.maxAttempts) {
        options.onRetry?.(attempt + 1);
        await sleep(options.delayMs);
      }
    }
  }
  throw lastError;
}
